import {Amplify} from "aws-amplify";

Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: import.meta.env.VUE_APP_USER_POOL_ID,
            userPoolClientId: import.meta.env.VUE_APP_USER_POOL_CLIENT_ID,
            loginWith: {
                oauth: {
                    domain: import.meta.env.VUE_APP_COGNITO_HOSTED_UI,
                    scopes: ["aws.cognito.signin.user.admin", "email", "openid"],
                    redirectSignIn: [import.meta.env.VUE_APP_REDIRECT_URL],
                    redirectSignOut: [import.meta.env.VUE_APP_REDIRECT_URL],
                    responseType: "code",
                    providers: [
                        { custom: import.meta.env.VUE_APP_FEDERATED_PROVIDER }
                    ]
                },
            },
            username: 'false',
            email: 'true',
            phone: 'false',
        },
    },
});